@if(filteredItems.length > 0){
    <div class="day-header mb-4 pt-4 row">
        @if(!day.today){
            <h4 class="mt-md-1 mb-md-0">{{day.date}}</h4>
        } @else {
            <h4 class="mt-md-1 mb-md-0">{{ 'today' | translate}} <small>- {{day.date}}</small></h4>
        }

        @if(moodItems.length >0){
            <div class="d-md-flex">
                <div class="moodsdistributionbar-blank"></div>
                <tm-moods-distribution-bar [moods]="moodItems"
                                           class="w-100 pt-3"></tm-moods-distribution-bar>
            </div>
        }
    </div>

    <div class="row daily-overview-moods pb-5 position-relative">
        @for(timelineItem of sortByCommentLength($safeNavigationMigration(filteredItems)); track timelineItem.id){
           
            <div class="col-tm-xl-6">
                @switch (timelineItem.itemType){
                    @case('moodItem'){
                        <tm-mood-card [mood]="($any(timelineItem))"
                                      [userInfos]="userInfos"
                                      (onEdit)="onEditMood($event)"
                                      (onDelete)="onDeleteTimelineItem($event)"
                                      (onModerate)="onModerateTimelineItem($event)"
                                      [isOdd]="$odd"></tm-mood-card>
                        } 

                    @case('kudosItem'){
                        <tm-kudos-card [kudos]="($any(timelineItem))"
                                       [teamId]="teamId"
                                       [userInfos]="userInfos"
                                       (onEdit)="onEditKudos($event)"
                                       (onDelete)="onDeleteTimelineItem($event)"
                                       (onModerate)="onModerateTimelineItem($event)"
                                       [isOdd]="$odd"></tm-kudos-card>
                    }

                    @case('badMoodPassItem'){
                        <tm-bad-mood-pass [badMoodPass]="($any(timelineItem))"
                                          [userInfos]="userInfos"
                                          [isOdd]="$odd"></tm-bad-mood-pass>
                    }

                    @case('badMoodStreakItem'){
                        <tm-bad-moodstreak [badMoodStreak]="($any(timelineItem))"
                                           [userInfos]="userInfos"
                                           [isOdd]="$odd"></tm-bad-moodstreak>
                    }

                    @case('topicItem'){
                        <tm-topic-card [topic]="($any(timelineItem))"
                                       [userInfos]="userInfos"
                                       (onEdit)="onEditTopic($event)"
                                       (onDelete)="onDeleteTimelineItem($event)"
                                       (onModerate)="onModerateTimelineItem($event)"
                                       [isOdd]="$odd"></tm-topic-card>
                    }

                    @case('tipsItem'){
                        <tip [tip]="($any(timelineItem))"></tip>
                    }

                    @case ('agreeDisagreeQuestionResultItem') {
                        <tm-agree-disagree-poll-result-card [pollResult]="($any(timelineItem))"
                                                                [userInfos]="userInfos"
                                                                [teamId]="teamId" 
                                                                [isOdd]="$odd"></tm-agree-disagree-poll-result-card>
        
                    }

                    @case ('scaleQuestionResultItem') {
                        <tm-scale-poll-result-card [pollResult]="($any(timelineItem))"
                                                       [userInfos]="userInfos"
                                                       [teamId]="teamId" 
                                                       [isOdd]="$odd"></tm-scale-poll-result-card>
        
                    }
        
                    @case ('closedQuestionResultItem') {
                        <tm-closed-poll-result-card [pollResult]="($any(timelineItem))"
                                                        [userInfos]="userInfos"
                                                        [teamId]="teamId"
                                                        [isOdd]="$odd"></tm-closed-poll-result-card>
        
                    }

                    @case ('fiveStarsQuestionResultItem') {
                        <tm-five-stars-poll-result-card [pollResult]="($any(timelineItem))"
                                                            [userInfos]="userInfos"
                                                            [teamId]="teamId"
                                                            [isOdd]="$odd"></tm-five-stars-poll-result-card>
        
                    }
                }
            </div>
        }
    </div>
}